module.exports = __webpack_public_path__ + "static/media/less_darkbleu.552bc9fe.svg";